import type { SVGProps } from 'react';

export const DatePicker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="32"
    viewBox="0 0 28 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_34025_68150)">
      <path
        d="M0.75 12H27.25C27.6625 12 28 12.3375 28 12.75V29C28 30.6562 26.6562 32 25 32H3C1.34375 32 0 30.6562 0 29V12.75C0 12.3375 0.3375 12 0.75 12ZM28 9.25V7C28 5.34375 26.6562 4 25 4H22V0.75C22 0.3375 21.6625 0 21.25 0H18.75C18.3375 0 18 0.3375 18 0.75V4H10V0.75C10 0.3375 9.6625 0 9.25 0H6.75C6.3375 0 6 0.3375 6 0.75V4H3C1.34375 4 0 5.34375 0 7V9.25C0 9.6625 0.3375 10 0.75 10H27.25C27.6625 10 28 9.6625 28 9.25Z"
        fill="#0D3F5E"
      />
    </g>
    <defs>
      <clipPath id="clip0_34025_68150">
        <rect width="28" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
